import React from "react"

import { button } from "./LogInOutButton.module.scss"

export const LogOutButton = ({ handleLogout, microcopy }) => (
  <span>
    <a onClick={handleLogout} className={button} data-logged-in>
      {microcopy.text("explorer.buttons.logout")}
    </a>
  </span>
)

export default LogOutButton
